module.exports = __webpack_public_path__ + "img/nf.eecfdfe2.svg";